/**
 * Handler per la gestione dei Time Reports
 * Compatibile con Vue.js - non utilizza tag <script> nei template
 */
export default class TimeReportsHandler {
    
    constructor() {
        this.init();
    }
    
    init() {
        // Verifica che jQuery sia disponibile
        if (typeof $ === 'undefined' || typeof jQuery === 'undefined') {
            setTimeout(() => this.init(), 50);
            return;
        }
        
        this.initializeTimeReportsHandlers();
    }
    
    initializeTimeReportsHandlers() {
        // Non usare un early return su #time-reports-table: il tab è spesso lazy-loaded via AJAX
        // sulla scheda progetto; i listener sono delegati su document e devono restare attivi.

        // Gestione pulsante per nuovo time report
        this.handleNewTimeReportButton();
        
        // Gestione pulsante per eliminazione time report
        this.handleDeleteTimeReportButtons();
        
        // Gestione campo "Includi in pacchetto"
        this.handlePackageInclusionFields();
    }
    
    handleNewTimeReportButton() {
        $(document).on('click', '#add-time-report', (e) => {
            e.preventDefault();
            
            // Ottieni il project_id dal data attribute o da una variabile globale
            const projectId = this.getProjectId();
            
            if (projectId) {
                // Imposta il project_id per il nuovo time report
                $('#templateModalTimeReport #project_id').val(projectId);
                
                // Apre la modale esistente per la creazione di un nuovo time report
                $('#templateModalTimeReport').modal('show');
            }
        });
    }
    
    handleDeleteTimeReportButtons() {
        $(document).on('click', '.delete-time-report', function(e) {
            e.preventDefault();
            
            const timeReportId = $(this).data('id');
            
            if (confirm('Sei sicuro di voler eliminare questo time report?')) {
                $.ajax({
                    url: '/time-reports-grid/' + timeReportId,
                    type: 'DELETE',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function(response) {
                        if (response.success) {
                            // Rimuove la riga dalla tabella
                            $('tr[data-id="' + timeReportId + '"]').remove();
                        }
                    },
                    error: function(error) {
                        console.error('Errore durante l\'eliminazione del time report');
                    }
                });
            }
        });
    }
    
    handlePackageInclusionFields() {
        let lastUpdateByReportId = {};

        $(document).on('change', '#time-reports-table select.timereport-editable[data-field="protected"]', function() {
            const $select = $(this);

            if ($select.data('timereport-saving')) {
                return;
            }

            const now = Date.now();
            const timeReportId = $select.data('id');
            const last = lastUpdateByReportId[timeReportId] || 0;

            if (now - last < 400) {
                return;
            }

            const field = $select.data('field');
            const value = $select.val();
            const projectId = TimeReportsHandler.getProjectIdFromElement(this);

            $select.data('timereport-saving', true);

            $.ajax({
                url: '/time-reports/' + timeReportId + '/update-field',
                type: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                data: {
                    field: field,
                    value: value
                },
                success: function(response) {
                    if (response.success) {
                        try {
                            const updateData = {
                                type: 'updatePackageStatus',
                                projectId: projectId,
                                timeReportId: timeReportId,
                                protected: (value == 1),
                                timestamp: Date.now()
                            };

                            localStorage.setItem('package_status_update', JSON.stringify(updateData));

                            if (window.opener && !window.opener.closed) {
                                try {
                                    window.opener.postMessage({
                                        type: 'forceUpdate',
                                        projectId: projectId
                                    }, '*');
                                } catch (e) {
                                }
                            }
                        } catch (e) {
                            console.error('Errore durante la comunicazione:', e);
                        }
                    } else {
                        console.error('Errore durante l\'aggiornamento');
                    }

                    lastUpdateByReportId[timeReportId] = Date.now();
                },
                error: function(error) {
                    console.error('Errore durante l\'aggiornamento:', error);

                    if (typeof toastr !== 'undefined') {
                        toastr.error('Impossibile salvare "Includi in pacchetto". Riprova.');
                    }
                },
                complete: function() {
                    $select.data('timereport-saving', false);
                }
            });
        });
    }
    
    getProjectId() {
        // Cerca il project_id in vari modi
        const projectIdElement = document.querySelector('[data-project-id]');
        if (projectIdElement) {
            return projectIdElement.dataset.projectId;
        }
        
        // Fallback: cerca in variabili globali se esistono
        if (typeof window.projectId !== 'undefined') {
            return window.projectId;
        }
        
        return null;
    }
    
    static getProjectIdFromElement(element) {
        // Metodo statico per ottenere il project_id da un elemento specifico
        const $element = $(element);
        
        // Cerca nei data attributes dell'elemento o dei suoi genitori
        let projectId = $element.closest('[data-project-id]').data('project-id');
        
        if (!projectId) {
            // Fallback: cerca in variabili globali
            projectId = window.projectId || null;
        }
        
        return projectId;
    }
}
